import queryString from 'qs';

import httpClient, { apiClient } from '@/libs/http-client';

import { IUser } from '../types';

// override instance default 'api base url' with 'middleware base url'
const prefixUrl = import.meta.env.VITE_MIDDLEWARE_BASE_URL;
const authURL = import.meta.env.VITE_AUTH_BASE_URL;

export const login = async ({
  method,
  ...data
}: {
  method: string;
  email: string;
  password: string;
}): Promise<IUser> => {
  return httpClient
    .post('login', { prefixUrl, json: { ...data, role: method, grant_type: 'password' } })
    .json();
};

export const resetPassword = async ({
  token,
  password1,
  password2,
}: {
  token: string;
  password1: string;
  password2: string;
}) => {
  return httpClient
    .post(`user/pass?h_id=${token}&target=webapp`, {
      prefixUrl: authURL,
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify({ password1, password2 }),
    })
    .json();
};

export const requestPasswordReset = async ({ email }: { email: string }) => {
  return httpClient
    .get(`user/pass-reset?email=${email}&target=webapp`, {
      prefixUrl: authURL,
      retry: { limit: 0 },
    })
    .json();
};

export const changeCurrentPassword = async ({
  currentPassword,
  password1,
  password2,
}: {
  currentPassword: string;
  password1: string;
  password2: string;
}) => {
  return apiClient()
    .post(`user/pass-change`, {
      prefixUrl: authURL,
      json: { current_password: currentPassword, password1, password2 },
    })
    .json();
};

export const refreshToken = async ({
  ...data
}: {
  refresh_token: string;
}): Promise<IUser> => {
  return httpClient
    .post('login', { prefixUrl, json: { ...data, grant_type: 'refresh_token' } })
    .json();
};

export const currentUser = async (): Promise<IUser> => {
  return apiClient().get('user', { prefixUrl: authURL }).json();
};
